<template>
  <ProductPromotionBanner
    v-if="promotion && hasFailedConditions"
    :custom-data="promotion.customData"
    view="basket"
    class="flex"
  />
</template>

<script setup lang="ts">
const props = defineProps<{ basketItem: FimBasketItem }>()

const basketItem = computed(() => props.basketItem)

const { promotion, hasFailedConditions } =
  await useBasketItemPromotion(basketItem)
</script>
